import React from 'react';
import { deletePhonenumberSetupCostParent, } from '@Api';
import { IAbilities, IAuth, IOrganizationStore, } from '@Store';
import { CrudEnum, IPreviewPhonenumberSetupCostParent, PermissionEnum, EnumTranslateTitle, TPhonenumberSetupCostParentSortableListCol, } from 'atlas-shared';
import { tableColumnDatetimeSorter, tableColumnStringSorter, timeSince, } from '@Utils';
import { TFunction, } from 'i18next';
import { NavigateFunction, } from 'react-router';
import { ColumnsType, } from 'antd/lib/table/interface';
import { listAuditButton, listCloneButton, listDeleteButton, listEditButton, GetColumnSearchLikeProps, GetColumnSearchEqualProps, } from '../components';
import { IWithListProps, } from '@Hocs/with.list';

export const PhonenumberSetupCostParentListColumns = (t: TFunction, navigate: NavigateFunction, showDeleted: boolean, organizations: IOrganizationStore, abilities: IAbilities, auth: IAuth, buttons: Array<(row: IPreviewPhonenumberSetupCostParent) => React.ReactElement> = [], filters: IWithListProps<IPreviewPhonenumberSetupCostParent, TPhonenumberSetupCostParentSortableListCol>['filters'], sorter: IWithListProps<IPreviewPhonenumberSetupCostParent, TPhonenumberSetupCostParentSortableListCol>['sorter']): ColumnsType<IPreviewPhonenumberSetupCostParent> => {
  return [
    {
      title: t('ID'),
      dataIndex: 'id',
      key: 'id',
      sorter: (a: IPreviewPhonenumberSetupCostParent, b: IPreviewPhonenumberSetupCostParent) => a.id - b.id,
      sortDirections: ['descend', 'ascend', ],
      sortOrder: sorter.find(s => s.column === 'id')?.order || null,
      filteredValue: filters.id || null,
      ...GetColumnSearchEqualProps(t, 'id', t('ID')),
      className: 'table-cell-id',
    },
    {
      title: t('TITLE'),
      dataIndex: 'title',
      key: 'title',
      sorter: (a: IPreviewPhonenumberSetupCostParent, b: IPreviewPhonenumberSetupCostParent) => tableColumnStringSorter(a.title, b.title),
      sortDirections: ['descend', 'ascend', ],
      sortOrder: sorter.find(s => s.column === 'title')?.order || null,
      filteredValue: filters.title || null,
      ...GetColumnSearchLikeProps(t, 'title', t('TITLE')),
      className: 'table-cell-title',
    },
    {
      title: t('CURRENCY'),
      dataIndex: 'currency',
      key: 'currency',
      render: (currency: IPreviewPhonenumberSetupCostParent['currency'], phonenumber_setup_cost_parent: IPreviewPhonenumberSetupCostParent) => EnumTranslateTitle('INVOICE_CURRENCY', currency, t),
      sorter: (a: IPreviewPhonenumberSetupCostParent, b: IPreviewPhonenumberSetupCostParent) => EnumTranslateTitle('INVOICE_CURRENCY', a.currency, t).localeCompare(EnumTranslateTitle('INVOICE_CURRENCY', b.currency, t)),
      sortDirections: ['descend', 'ascend', ],
      sortOrder: sorter.find(s => s.column === 'currency')?.order || null,
      className: 'table-cell-currency',
    },
    {
      title: t('CREATED_AT'),
      dataIndex: 'created_at',
      key: 'created_at',
      render: (created_at: IPreviewPhonenumberSetupCostParent['created_at'], phonenumber_setup_cost_parent: IPreviewPhonenumberSetupCostParent) => <div className='date-column'>{created_at ? timeSince(t, new Date(created_at), true) : ''}</div>,
      sorter: (a: IPreviewPhonenumberSetupCostParent, b: IPreviewPhonenumberSetupCostParent) => tableColumnDatetimeSorter(a.created_at, b.created_at),
      sortDirections: ['descend', 'ascend', ],
      sortOrder: sorter.find(s => s.column === 'created_at')?.order || null,
      className: 'table-cell-created_at',
    },
    
    {
      title: '',
      dataIndex: 'operation',
      key: 'operation',
      render: (_: any, row: IPreviewPhonenumberSetupCostParent) => (
        <div className={'table-operation-wrp'}>
          {buttons.map(button => button(row))}
          {abilities.can(null, CrudEnum.Insert, PermissionEnum.PhonenumberSetupCostParent, row) && listCloneButton(t, navigate, 'phonenumber_setup_cost_parent', row)}
          {abilities.can(null, CrudEnum.Read, PermissionEnum.Audit, row) && listAuditButton(t, navigate, 'phonenumber_setup_cost_parent', row)}
          {abilities.can(null, CrudEnum.Update, PermissionEnum.PhonenumberSetupCostParent, row) && listEditButton(t, navigate, 'phonenumber_setup_cost_parent', row)}
          {abilities.can(null, CrudEnum.Delete, PermissionEnum.PhonenumberSetupCostParent, row) && listDeleteButton(t, row, deletePhonenumberSetupCostParent)}
        </div>
      ),
    },
  ].filter(Boolean) as ColumnsType<IPreviewPhonenumberSetupCostParent>;

};
